export class CompanyFormFieldsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyFormFields({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/form-fields`);
  }

  async editCompanyFormFields({ companyId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/form-fields`, body);
  }

  async createCompanyTrustee({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/form-fields/trustees`, body);
  }

  async editCompanyTrustee({ companyId, trusteeId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/form-fields/trustees/${trusteeId}`, body);
  }

  async deleteCompanyTrustee({ companyId, trusteeId }) {
    return this.#http.delete(`/api/companies/${companyId}/form-fields/trustees/${trusteeId}`);
  }
}
